<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import { classNames,UpdateBulkRollNumber,enrollStudentActiveLists } from "@/services/apiServices";
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";
import { useTheme } from '@/composables/useThemes'
const { isDarkTheme } = useTheme()
import { useClassStore } from "@/Store/className";
const route = useRoute();
const classStore = useClassStore();
const initialLoading = ref(false);
const fetchedStudents = ref([]);
const selectedYear = ref(null)
const selectedClass = ref(null)
const classInfoList = computed(() => classStore.classInfoList);
const loading = computed(() => classStore.loading);
const error = ref("");
watch(selectedClass, async (newClassId) => {
  if (!newClassId) {
    fetchedStudents.value = [];
    return;
  }
  try {
    const response = await enrollStudentActiveLists(newClassId);
    if (!response || response.length === 0) {
      Swal.fire({icon: "error",title: "Oops...",text: "Sorry student not found",});
      fetchedStudents.value = [];
    } else {
      fetchedStudents.value = response.filter(Boolean);
    }
  } catch (err) {
    console.error('Failed to fetch students:', err);
    fetchedStudents.value = [];
  }
});

const getImage = (item) => {  return item ? `${apiConfig.imageUrl}${item}` : banner1;}
const classItems = computed(() =>
  classInfoList.value.map(item => ({
    title: item.name,
    value: item.id
  }))
);
const years = [{ title: '२०८३', value: '2083' },]
// const filteredYears = years;
const fetchClassInfoList = async () => {
  try {
    initialLoading.value = true;
    const data = await classNames();
    classStore.setClassInfoList(data);
  } catch (err) {
    console.error("Failed to fetch class info list:", err);
    error.value = err.response?.data?.message || "Something went wrong";   
  } finally {initialLoading.value = false;}
};
const onYearChange = async (year) => {
  selectedYear.value = year
  localStorage.setItem("selectedYear", year)
  selectedClass.value = null;  
}
onMounted(async () =>{fetchClassInfoList();});
const SearchStudent = async () => {
  const source =mode.value === "alpha"? displayedStudents.value: fetchedStudents.value;
  const payload = source.map(student => ({
    id: student.id,
    roll_no: student.roll_no,
    year: student.year
  }));
  try {
    await UpdateBulkRollNumber(payload);
    Swal.fire({
      icon: "success",
      title: "Updated",
      text: "Record updated",
    });
    fetchedStudents.value = [];
    selectedClass.value = null;
  } catch (e) {
    console.error(e);
  }
};
const mode = ref("manual");
const displayedStudents = computed(() => {
  let students = [...fetchedStudents.value];
  if (mode.value === "alpha") {
    students.sort((a, b) => a.name.localeCompare(b.name));
    students = students.map((s, index) => ({...s,roll_no: index + 1}));
  }
  return students;
});

</script>

<template>
  <v-container>
    <div class="d-flex align-center justify-space-between">    
      <div class="top_div" style="display: flex;justify-content: space-between;width: 100%;">
        <div style="width:100%;display: flex;flex-direction: column;">
          <div >Search Student </div>
          <div style="display: flex;gap: 15px;">
            <!-- <v-sheet style="width: 50%">
            <v-select
              v-model="selectedYear"
              :items="filteredYears"
              item-title="title"
              item-value="value"
              label="Select Year"
              @update:modelValue="onYearChange"
            />
          </v-sheet>     -->
          <v-sheet class="selectsheet" style="width: 50%">
            <v-select v-model="selectedClass" :items="classItems" item-title="title" item-value="value" label="Select Class" outlined dense />
          </v-sheet>        
          </div>        
        </div>
      </div>
    </div>
    <div class="table-section">
      <div class="button-div">
        <v-btn color="primary" style="margin-top: 15px;" @click="SearchStudent"  :disabled="!displayedStudents || displayedStudents.length === 0">
          Update
        </v-btn>
      </div>
      <div class="table-div">
        <table border="1" style="width: 100%;">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Roll No <br/>
                <select v-model="mode" class="selectsheet">
                  <option value="manual">Manual</option>
                  <option value="alpha">Alphabetical</option>
                </select>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(student, index) in displayedStudents" :key="student.id">
              <td>{{ index + 1 }}</td>
              <td>{{ student.name }}</td>
              <td><input v-model="student.roll_no" type="text"  :readonly="mode === 'alpha'"/></td>
            </tr>
          </tbody>
        </table>
      </div>   
    </div>
  </v-container>
</template>

<style>
.table-section{display: flex;flex-direction: column;}
.button-div{display: flex;align-self: flex-end;margin: 10px;}
table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}
th, td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}
th {
  background-color: #f4f6f8;
  font-weight: bold;
}
tr:nth-child(even) {background-color: #fafafa;}
tr:hover {
  background-color: #f1f1f1;
}
td input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
td input:focus {
  outline: none;
  border-color: #007bff;
  background-color: #eef6ff;
}
select {
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
select:focus {border-color: #42b983;}
@media (max-width: 600px) {.selectsheet {width: 100% !important;}}

</style>